var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"text-pagename"},[_vm._v("Vehicle type management")]),_c('vehicleTypeManage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }